import axios from "axios";

export const submitHubspotContactForm = async (
  email: string,
  firstname: string,
  lastname: string,
  company: string,
  message: string,
  projectTypes: string,
  timeline: string,
  budget: string
) => {
  const portalId = "46411654";
  const formGuid = "c668ee05-f69c-44ae-be1f-21e7142edd6b";
  const config = {
    headers: {
      "Content-Type": "application/json",
    },
  };

  const response = await axios.post(
    `https://api.hsforms.com/submissions/v3/integration/submit/${portalId}/${formGuid}`,
    {
      portalId,
      formGuid,
      fields: [
        {
          name: "firstname",
          value: firstname,
        },
        {
          name: "lastname",
          value: lastname,
        },
        {
          name: "email",
          value: email,
        },
        {
          name: "company",
          value: company,
        },
        {
          name: "message",
          value: message,
        },
        {
          name: "projecttypes",
          value: projectTypes,
        },
        {
          name: "timeline",
          value: timeline,
        },
        {
          name: "budget",
          value: budget,
        },
      ],
    },
    config
  );
  return response;
};
